import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-129ff164"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "widget" };
const _hoisted_2 = { class: "pb-2" };
const _hoisted_3 = {
    key: 0,
    class: "listItem is-small mb-2"
};
const _hoisted_4 = { class: "tag is-white is-rounded is-medium has-text-weight-bold" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-paperclip mr-3" }, null, -1));
const _hoisted_7 = { class: "listFilename" };
const _hoisted_8 = ["onClick"];
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1));
const _hoisted_10 = [
    _hoisted_9
];
const _hoisted_11 = {
    key: 0,
    class: "file has-name is-link is-small"
};
const _hoisted_12 = { class: "file-label" };
const _hoisted_13 = ["disabled", "multiple"];
const _hoisted_14 = { class: "file-cta" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "file-icon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-upload" })
], -1));
const _hoisted_16 = { class: "file-label" };
const _hoisted_17 = {
    key: 0,
    class: "file-name"
};
import { ref, computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DocumentUploadWidget',
    props: {
        documents: {},
        singleDocument: {},
        readonly: { type: Boolean }
    },
    emits: ["delete", "view", "upload"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const documentToDelete = ref(null);
        const uploadInProgress = ref(false);
        const effectiveDocuments = computed(() => {
            if (props.documents)
                return props.documents;
            return props.singleDocument ? [props.singleDocument] : [];
        });
        const emit = __emit;
        const filename = ref(null);
        const deleteDocument = (doc) => {
            documentToDelete.value = null;
            emit('delete', doc);
        };
        const viewDocument = (doc) => {
            emit('view', doc);
        };
        const uploadDocuments = (files) => {
            let i = 0;
            const uploadNextDocument = () => {
                filename.value = `(${i + 1}/${files.length}) - ${files[i].name}`;
                uploadInProgress.value = true;
                emit('upload', {
                    file: files[i],
                    onDone: () => {
                        i++;
                        if (i < files.length) {
                            // There are more files
                            if (props.documents != null) {
                                // This is a multi-document upload widget, so we should upload the next file
                                uploadNextDocument();
                            }
                            else {
                                // This is a single-document upload widget, so only one file can be uploaded
                            }
                        }
                        else {
                            // We're done
                            filename.value = null;
                            uploadInProgress.value = false;
                        }
                    }
                });
            };
            uploadNextDocument();
        };
        return (_ctx, _cache) => {
            var _a;
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (((_a = effectiveDocuments.value) === null || _a === void 0 ? void 0 : _a.length) == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, "None Provided"))
                            : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effectiveDocuments.value, (document) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "listItem mb-2",
                                key: document.id
                            }, [
                                _createElementVNode("span", _hoisted_4, [
                                    _createElementVNode("a", {
                                        onClick: ($event) => (viewDocument(document))
                                    }, [
                                        _hoisted_6,
                                        _createElementVNode("span", _hoisted_7, _toDisplayString(document.filename), 1)
                                    ], 8, _hoisted_5)
                                ]),
                                (!_ctx.readonly)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 0,
                                        onClick: ($event) => (documentToDelete.value = document),
                                        class: "ml-3 mr-3"
                                    }, _hoisted_10, 8, _hoisted_8))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ]),
                    (!_ctx.readonly)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("label", _hoisted_12, [
                                _createElementVNode("input", {
                                    class: "file-input",
                                    type: "file",
                                    name: "file",
                                    disabled: uploadInProgress.value,
                                    multiple: _ctx.documents !== undefined,
                                    onChange: _cache[0] || (_cache[0] = ($event) => (uploadDocuments($event.target.files)))
                                }, null, 40, _hoisted_13),
                                _createElementVNode("span", _hoisted_14, [
                                    _hoisted_15,
                                    _createElementVNode("span", _hoisted_16, _toDisplayString(uploadInProgress.value ? "Uploading…" : (_ctx.singleDocument ? "Replace File…" : "Attach File…")), 1)
                                ]),
                                (filename.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(filename.value), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createVNode(_component_ModalDialog, {
                    active: documentToDelete.value != null,
                    title: "Confirm Delete",
                    "allow-close": true,
                    onClose: _cache[1] || (_cache[1] = ($event) => (documentToDelete.value = null)),
                    "first-button-text": "Go Back",
                    "first-button-severity": "link",
                    onFirstbuttonselected: _cache[2] || (_cache[2] = ($event) => (documentToDelete.value = null)),
                    "second-button-text": "Delete",
                    "second-button-severity": "danger",
                    onSecondbuttonselected: _cache[3] || (_cache[3] = ($event) => (deleteDocument(documentToDelete.value)))
                }, {
                    default: _withCtx(() => {
                        var _a;
                        return [
                            _createElementVNode("p", null, [
                                _createElementVNode("strong", null, "Delete " + _toDisplayString((_a = documentToDelete.value) === null || _a === void 0 ? void 0 : _a.filename) + "?", 1)
                            ])
                        ];
                    }),
                    _: 1
                }, 8, ["active"])
            ], 64));
        };
    }
});
